














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { applyDrag } from '@/utils/helpers';

import dayjs from 'dayjs';
import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);

/**
 * CTI目录组件
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */

@Component
export default class Catalog extends Vue {
    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;
    @Prop({ default: false })
    allowAdd: Boolean;
    @Prop({ default: false })
    allowDelete: Boolean;
    @Prop({ default: false })
    allowEdit: Boolean;
    @Prop()
    level: number;
    @Prop({ default: true })
    hasNext: Boolean;
    @Prop({ default: () => [] })
    list: CommonTypes.CatalogItem[];
    @Prop({ default: 0 })
    activeId: number;
    $refs: any;
    isScorll: Boolean = false;

    @Watch('list', { immediate: true })
    onListChanged() {
        const menuRef = this.$refs.categoryMenu;
        if (menuRef) {
            // 目录数量过多则把添加按钮固定在页面底部
            this.$nextTick(function () {
                this.isScorll = menuRef.$el.scrollHeight > menuRef.$el.clientHeight;
            });
        }
    }
    @Watch('activeId', { immediate: true })
    onGetActiveId() {
        if (this.activeId) {
            this.$nextTick(() => {
                this.$refs.categoryMenu.activeIndex = this.activeId.toString();
            });
        }
    }
    getChildPayload(index) {
        return this.list[index];
    }
    selectMenu(index: string) {
        this.$emit('change-select', parseInt(index, 10));
    }
    onDrop(dropResult) {
        if (!this.userInfo.sysAdmin) {
            return;
        }
        const { removedIndex, addedIndex } = dropResult;
        // 每次拖拽重新填装数据 忽略这种情况触发的事件
        if (removedIndex === null || addedIndex === null || removedIndex === addedIndex) {
            return;
        }
        const list = applyDrag(this.list, dropResult);
        const ids = list.map(item => {
            return item.id;
        });
        this.$emit('drop-handler', this.level, ids, list);
    }
    deleteMenu(id: number) {
        this.$emit('delete', id);
    }
    editMenu(id: number) {
        this.$emit('edit', id);
    }
    linkFilter(link: string) {
        if (!link) {
            return '';
        }
        return link.replace(/\+/g, '%2B');
    }
    getCreateTime(time: number) {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    }
    handleCopySuccess() {
        this.$mtd.message({
            message: '复制TT链接成功',
            type: 'success'
        });
    }
    mounted() {
        const menuRef = this.$refs.categoryMenu;
        if (menuRef) {
            this.$nextTick(function () {
                this.isScorll = menuRef.$el.scrollHeight > menuRef.$el.clientHeight;
            });
        }
    }
}
